



























import { Vue, Component, Prop } from 'vue-property-decorator';

import InputError from '~/components/inputs/InputError.vue';

@Component({
  components: { InputError },
})
export default class AreaInput extends Vue {
  @Prop(String) label: ''
  @Prop(String) placeholder: '';
  @Prop(String) value: '';
  @Prop(Object) v: () => ({});
  @Prop(Object) vMessages: () => ({});
  @Prop(Boolean) autofocus: false;

  $refs: {
    input: HTMLInputElement,
    label: HTMLLabelElement,
  };

  /* Destructuring v-model in a getter/setter to have a custom input container */
  get inputValue () {
    return this.value;
  }

  /* ⬆️ */
  set inputValue (value) {
    this.$emit('input', value);
  }

  /*
    Computed will listen every other events listened by the input, and catchable
    in the parent itself
  */
  get listenersExceptInput () {
    /* eslint-disable-next-line */
    const { input: _, ...otherListeners } = this.$listeners;
    return otherListeners;
  }

  /* Will focus the input if this.autofocus prop is defined */
  mounted () {
    if (this.autofocus) this.$refs.input.focus();
  }
};
